import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaArrowLeft } from 'react-icons/fa';
import './index.css';

function DebugIcal() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { villaId, villaTitle } = state || {};
  const [firestoreDates, setFirestoreDates] = useState([]);
  const [icalEvents, setIcalEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDebugData = async () => {
      if (!villaId) {
        setError('No villa ID provided');
        setLoading(false);
        toast.error('No villa ID provided', {
          position: 'top-right',
          autoClose: 3000,
        });
        return;
      }

      try {
        const response = await fetch('https://luxe-backend.netlify.app/debug-ical', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ villaId }),
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch debug data: ${response.statusText}`);
        }

        const data = await response.json();
        setFirestoreDates(data.firestoreDates || []);
        setIcalEvents(data.icalEvents || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching debug data:', err);
        setError(err.message || 'Error fetching debug data');
        setLoading(false);
        toast.error(err.message || 'Error fetching debug data', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    };

    fetchDebugData();
  }, [villaId]);

  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error">
        <ToastContainer />
        {error}
      </div>
    );
  }

  return (
    <div className="debug-ical-container">
      <ToastContainer />
      <button className="back-btn" onClick={() => navigate(-1)}>
        <FaArrowLeft /> Back
      </button>
      <h2>Debug iCal Dates for {villaTitle || 'Villa'} (ID: {villaId})</h2>
      <div className="debug-section">
        <h3>Firestore Blocked Dates</h3>
        {firestoreDates.length > 0 ? (
          <ul>
            {firestoreDates.sort().map((date) => (
              <li key={date}>{format(new Date(date), 'dd MMM yyyy')}</li>
            ))}
          </ul>
        ) : (
          <p>No blocked dates in Firestore</p>
        )}
      </div>
      <div className="debug-section">
        <h3>iCal Events</h3>
        {icalEvents.length > 0 ? (
          <ul>
            {icalEvents.map((event) => (
              <li key={event.bookingId}>
                <p><strong>Booking ID:</strong> {event.bookingId}</p>
                <p><strong>Start:</strong> {format(new Date(event.start), 'dd MMM yyyy')}</p>
                <p><strong>End:</strong> {format(new Date(event.end), 'dd MMM yyyy')}</p>
                <p><strong>Summary:</strong> {event.summary}</p>
                <p><strong>Description:</strong> {event.description}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p>No events in iCal feed</p>
        )}
      </div>
    </div>
  );
}

export default DebugIcal;